/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

const StyledButton = styled('button')`
  padding: 8px 16px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  &:disabled {
    background-color: ${COLORS.GRAY_200};
    color: ${COLORS.GRAY_500};
    cursor: not-allowed;
    border: 1px solid ${COLORS.GRAY_300};
  }

  &.cancelButton {
    border: 1px solid ${COLORS.GRAY_100};

    &:hover {
      background-color: ${COLORS.GRAY_100};
    }

    &:disabled {
      background-color: ${COLORS.GRAY_100};
      color: ${COLORS.GRAY_300};
      border-color: ${COLORS.GRAY_100};
    }
  }

  &.confirmButton {
    background-color: ${COLORS.PRIMARY};
    color: white;

    &:hover {
      background-color: ${COLORS.PRIMARY_HOVER};
    }

    &:disabled {
      background-color: ${COLORS.PRIMARY_DISABLED};
      color: white;
      border-color: ${COLORS.GRAY_300};
    }
  }
`;

export default StyledButton;
